export default __webpack_public_path__ + "static/media/path.0fdf01ad.png";